import { ConditionValue, OperationEnum, Sanitizer, SanitizersMapper } from '../types';
import { BooleanSanitizersMapper } from '../boolean';
import { StringSanitizersMapper } from '../string/sanitizers';
import { DateSanitizersMapper } from '../date/sanitizers';
import { NumericSanitizersMapper } from '../numeric';

const SanitizersMapper: SanitizersMapper<ConditionValue> = {
  ...StringSanitizersMapper,
  ...NumericSanitizersMapper,
  ...DateSanitizersMapper,
  ...BooleanSanitizersMapper,
};

export function useSanitizer(operation: OperationEnum): Sanitizer<ConditionValue> | undefined {
  return SanitizersMapper[operation];
}
